import loginCover from './login_cover.jpg'
import blazeRetailLogo from './blaze_retail_logo.svg'
import distributionLogo from './distributionLogo.png'
import dispatchLogo from './dispatchLogo.png'
import insightsLogo from './insightsLogo.png'
import retailLogo from './retailLogo.png'
import growLogo from './growLogo.png'
import C2QB from './C2QB_green.png'
import QuickBookGrey from './quickbook_grey.png'
import QuickBookWhite from './quickbook_white.png'
import SpringBigGrey from './springbig-logo-grey.svg'
import SpringBigWhite from './springbig-logo-white.svg'
import OnfleetGrey from './onfleet-logo-grey.svg'
import OnfleetWhite from './onfleet-logo-white.svg'
import MTracGrey from './mtrac_grey.png'
import MTracWhite from './mtrac_white.png'
import CloverGrey from './clover-grey.png'
import CloverWhite from './clover-white.png'
import LeaflyGrey from './leafly-grey.svg'
import LeaflyWhite from './leafly-white.svg'
import WeedmapsGrey from './weedmaps-logo-grey.svg'
import WeedmapsWhite from './weedmaps-logo-white.svg'
import SpencePurple from './spence-purple.svg'
import SpenceGray from './spence-gray.svg'
import UniqueAttributesWhite from './unique-attributes-white.png'
import UniqueAttributesGrey from './unique-attributes-grey.png'
import NoImagePlaceholder from './no-image.jpg'
import VerticalDots from './vertical-dots.svg'
import DifferentValue from './different-value.svg'
import SameValue from './same-value.svg'
import LinkValue from './link-value.svg'
import UnLinkValue from './no-link-value.svg'
import ImportInvBatch from './import.svg'
import ExportInvBatch from './export.svg'
import PreviousPage from './previousPage.svg'
import NextPage from './nextPage.svg'
import TemplateProducts from './template-master-products.csv'
import InfoIcon from './info-icon.svg'
import BlazeInsightsIcon from './blaze-insights.png'
import stronghold from './stronghold.png'
import strongholdGray from './strongholdGray.png'
import ErrorIconFees from './erroricon.svg'
import WmDispatchLogo from './wmDispatch_logo.svg'
import QrCodeSvg from './qr_code.svg'

export {
  loginCover,
  blazeRetailLogo,
  distributionLogo,
  dispatchLogo,
  insightsLogo,
  retailLogo,
  growLogo,
  C2QB,
  QuickBookGrey,
  QuickBookWhite,
  SpringBigGrey,
  SpringBigWhite,
  WeedmapsGrey,
  WeedmapsWhite,
  OnfleetGrey,
  OnfleetWhite,
  MTracGrey,
  MTracWhite,
  CloverGrey,
  CloverWhite,
  LeaflyGrey,
  LeaflyWhite,
  UniqueAttributesWhite,
  UniqueAttributesGrey,
  NoImagePlaceholder,
  SpencePurple,
  SpenceGray,
  VerticalDots,
  DifferentValue,
  SameValue,
  LinkValue,
  UnLinkValue,
  ImportInvBatch,
  ExportInvBatch,
  PreviousPage,
  NextPage,
  TemplateProducts,
  InfoIcon,
  BlazeInsightsIcon,
  stronghold,
  strongholdGray,
  WmDispatchLogo,
  ErrorIconFees,
    QrCodeSvg,
}



// WEBPACK FOOTER //
// ./src/assets/index.js